import { render, staticRenderFns } from "./Armando.vue?vue&type=template&id=4fe38032&scoped=true"
import script from "./Armando.vue?vue&type=script&lang=js"
export * from "./Armando.vue?vue&type=script&lang=js"
import style0 from "./Armando.vue?vue&type=style&index=0&id=4fe38032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe38032",
  null
  
)

export default component.exports